import React, { useState } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Grid,
  GridItem,
  Switch,
  Card,
  Link,
} from "@chakra-ui/react";
import PortfolioItem from "./WorkPages/PortfolioItem";
import ResumeItem from "./ResumeItem";
import { portfolio } from "../info/portfolioInfo";
import { workExperience } from "../info/resumeinfo";
import LabelSwitch from "./WorkPages/LabelSwitch";
import DesignItem from "./DesignItem";
import { IoMdOpen } from "react-icons/io";
import ResumePDF from "../documents/Jessica_Wan_Resume_2024.pdf";

export default function Resume() {
  return (
    <div id="resume" style={{ transition: "all 4s ease" }}>
      <Grid
        templateAreas={{
          lg: `"main download"`,
          base: `"download"
                "main"`,
        }}
        gridTemplateColumns={{ lg: "1fr .7fr", base: "1fr" }}
        gridTemplateRows={{ lg: "1fr", base: ".2fr 1fr" }}
        minHeight="50vh"
        px={{ base: "5rem", lg: "10rem" }}
        py="5rem"
        overflow={"hidden"}
        bg="darkestgrey"
        transition="height 1s"
      >
        <GridItem
          area={"download"}
          display={"flex"}
          flexDir={"column"}
          alignItems={{ lg: "flex-end", base: "center" }}
          justifyContent={{ lg: "flex-start", base: "center" }}
          gap="1rem"
          mb="3rem"
        >
          <Text
            variant={"subHeader"}
            textAlign={{ lg: "right", base: "center" }}
            lineHeight={"80%"}
            color="offwhite"
          >
            Professional Experience
          </Text>

          <Link href={ResumePDF} target="_blank">
            <Button
              variant="outline"
              px="2rem"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "white", color: "white" }}
              gap=".5rem"
            >
              <IoMdOpen />
              Download PDF
            </Button>
          </Link>
        </GridItem>
        <GridItem
          area={"main"}
          display="flex"
          alignItems="flex-start"
          flexDir={"column"}
          overflowWrap={"break-word"}
          overflowX={"hidden"}
          gap="1rem"
        >
          {workExperience.map((p, key) => (
            <ResumeItem
              position={p.position}
              employer={p.employer}
              year={p.year}
              description={p.description}
            />
          ))}
        </GridItem>
      </Grid>
    </div>
  );
}
